const MuiContainerOverrides = {
  MuiContainer: {
    styleOverrides: {
      root: _ref => {
        let {
          theme,
          ownerState
        } = _ref;
        return {
          marginLeft: 0,
          marginRight: 0,
          ...(!ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            [theme.breakpoints.up('sm')]: {
              paddingLeft: theme.spacing(5),
              paddingRight: theme.spacing(5)
            }
          })
        };
      }
    }
  }
};

export { MuiContainerOverrides };
